// Analytics API helpers using apiFetch to attach API key
import { apiFetch } from '../../shared/api/apiClient';

export async function fetchDashboard(): Promise<any> {
  const res = await apiFetch('/api/analytics/kpis');
  if (!res.ok) throw new Error('Failed to load analytics dashboard');
  return res.json();
}

export async function fetchPayments(): Promise<any> {
  const endDate = new Date().toISOString().split('T')[0];
  const startDate = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0];
  const res = await apiFetch(`/api/analytics/payments?startDate=${startDate}&endDate=${endDate}`);
  if (!res.ok) throw new Error('Failed to load payment analytics');
  return res.json();
}

export async function fetchSubscriptions(): Promise<any> {
  const res = await apiFetch('/api/analytics/subscriptions');
  if (!res.ok) throw new Error('Failed to load subscription analytics');
  return res.json();
}

export async function fetchRevenue(): Promise<any> {
  const endDate = new Date().toISOString().split('T')[0];
  const startDate = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0];
  const res = await apiFetch(`/api/analytics/payments?startDate=${startDate}&endDate=${endDate}`);
  if (!res.ok) throw new Error('Failed to load revenue analytics');
  return res.json();
}

export default { fetchDashboard, fetchPayments, fetchSubscriptions, fetchRevenue };

